<script setup>
const route = useRoute()
const headConfig = useHeadConfig()
useHead(headConfig)

// Update the page title when the route changes
watch(() => route.meta.title, (newTitle) => {
  useHead({ title: newTitle || null })
}, { immediate: true })
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>


<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

body {
  @apply font-[Poppins] antialiased;
}
</style>